import React, { useState, useEffect, useRef } from "react";
import { ReactComponent as MagnifyingGlass } from "../../../../../assets/magnifying-glass.svg";
import AssociateProductBarcodeController from "../../../../AssociateProductBarcode/AssociateProductBarcodeController";
import Input from "./Input";
import styles from "./ScanInput.module.css";
import { useTranslation } from "react-i18next";

const SearchForProducts = ({
  user,
  setProductsSearchText,
  enforceInputFocus,
  setEnforceInputFocus,
  productsSearchText,
  onSetErrorHandler,
  errorMsg,
}) => {
  const { t } = useTranslation("stock")

  const [value, setValue] = useState("");
  const _controller = useRef(null);
  const placeHolder = t("searchProductPlaceholder");

  useEffect(() => {
    _controller.current = new AssociateProductBarcodeController(user);
  }, []);

  useEffect(() => {
    if (!productsSearchText) {
      setValue("");
    }
  }, [productsSearchText]);

  const changeScanInputHandler = (e) => {
    setValue(e.target.value);
  };

  // searchForProducts
  const callback = (error, products) => {
    if (!error && products && products.length > 0) {
      // console.log("products", products);
    } else if (!error && products && products.length === 0) {
      onSetErrorHandler(t("noProductFoundError"));
    } else {
      console.log("error:", error);
      onSetErrorHandler(t("noProductRetrievedError"));
    }
  };

  const onKeyUpHandler = (e) => {
    if (e.which === 13) {
      setProductsSearchText(e.target.value);
      _controller.current.searchForProducts(e.target.value, callback);
    }
  };

  return (
    <section className={styles.scanInput__container}>
      <MagnifyingGlass className={styles.scanInput__magnifyingGlassIcon} />
      <Input
        className={styles.scanInput__field}
        onChangeHandler={changeScanInputHandler}
        onKeyUpHandler={onKeyUpHandler}
        value={value}
        placeHolder={placeHolder}
        enforceInputFocus={enforceInputFocus}
        setEnforceInputFocus={setEnforceInputFocus}
        errorMsg={errorMsg}
      />
    </section>
  );
};

export default SearchForProducts;
